module.exports = __webpack_public_path__ + "img/shop-Info.8b024b11.png";